'use es6';

import * as SurveyTypes from 'feedback-schema/constants/surveyTypes';
import { CsatWebSurveyConfigRecord, NpsWebSurveyConfigRecord } from 'feedback-schema/records/WebSurveyConfigRecord';
export default (config => new {
  [SurveyTypes.CSAT]: CsatWebSurveyConfigRecord,
  [SurveyTypes.NPS]: NpsWebSurveyConfigRecord
}[config.surveyType](Object.assign({}, config)));